import React from 'react';
import PropTypes from 'prop-types';
import { ThumbsUp as IconThumbsUp } from 'lucide-react';

const ThumbsUp = ({ size, className }) =>  (
  <div className={`${className} w-[${size}px] h-[${size}px] bg-[#E6F3FD] flex items-center justify-center rounded-full`}>
    <IconThumbsUp className="w-8 h-8" color="#008AEA" />
  </div>
);

ThumbsUp.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

ThumbsUp.defaultProps = {
  size: 72,
  className: '',
};

export default ThumbsUp;
